export default {
  data() {
    return {
      localizedAllergies: [
        {
          key: "Dairy",
          value: 'message.allergyDairy'
        },
        {
          key: "Gluten",
          value: "message.allergyGluten"
        },
        {
          key: "Celery",
          value: "message.allergyCelery"
        },
        {
          key: "Yeast",
          value: "message.allergyYeast"
        },
        {
          key: "Shellfish",
          value: "message.allergyShellfish"
        },
        {
          key: "Alcohol",
          value: "message.allergyAlcohol"
        },
        {
          key: "Peanuts",
          value: "message.allergyPeanuts"
        },
        {
          key: "Lupin",
          value: "message.allergyLupin"
        },
        {
          key: "Soybeans",
          value: "message.allergySoybeans"
        },
        {
          key: "Fish",
          value: "message.allergyFish"
        },
        {
          key: "Eggs",
          value: "message.allergyEggs"
        },
        {
          key: "Mustard",
          value: "message.allergyMustard"
        },
        {
          key: "Sulphites",
          value: "message.allergySulphites"
        }
      ]
    }
  },
  methods: {
    localizeAllergy(key) {
      let self = this;
      let localizedAllergy = self.localizedAllergies.filter(function (item) {
        return item.key === key;
      });
      if (localizedAllergy.length > 0) {
        return self.$t(localizedAllergy[0].value);
      }
      else {
        return key;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/Allergies/index.js